/* eslint-disable no-sequences */
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

(actionsStyles.unitOfMeasureSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 20px;
            display: flex;
            width: 70% !important;
            flex-direction: row;
            align-items: center;
            margin-top: 10px;
            /* margin-bottom: 10px; */
            label {
                width: 25% !important;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100% !important;
                                /* width: 22%; */
                            `,
                            css`
                                width: 100% !important;
                                /* width: 22%; */
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
            }
            div[class^="FormInputWrapper"] {
                width: 100%;
                /* margin-top: 0px !important; */
            }
        `,
    },
}),
    (actionsStyles.addToCartWrapper = {
        css: css`
            display: flex;
            align-items: flex-end;
            /* margin-top: 10px; */
            margin-bottom: 10px;
            div[class^="FormFieldStyle"] {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 35%;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                /* width: 45%; */
                            `,
                            css`
                                /* width: 45%; */
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    );
                }}
                label {
                    font-size: 14px;
                    width: 55%;
                    ${({ theme }) => {
                        return breakpointMediaQueries(theme, [
                            css`
                                width: 85%;
                            `,
                            css`
                                width: 85%;s
                            `,
                            null,
                            null,
                        ]);
                    }}
                }
                div[class^="FormInputWrapper"] {
                    margin-top: 0px;
                    /* width: 35%; */
                    input[type="number"] {
                        /* height: 36px; */
                    }
                }
            }
        `,
    }),
    (actionsStyles.addToCartButton = {
        css: css`
            width: 65%;
        `,
    });

actionsStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        flex-direction: column;
        background: #f8f8f8;
        padding: 14px 14px 10px 14px;
    `,
};
